import { AbstractControl, FormArray } from '@angular/forms';

// TODO move
export function overrideFormArray(): void {
    // patch in what future versions do
    // eslint-disable-next-line @typescript-eslint/dot-notation
    FormArray.prototype['clear2'] = function (): void {
        if (this.controls.length < 1) return;
        // eslint-disable-next-line @typescript-eslint/dot-notation
        this._forEachChild((control: AbstractControl) =>
            // eslint-disable-next-line @typescript-eslint/dot-notation
            control['_registerOnCollectionChange'](() => {
                /**/
            }),
        );
        this.controls.splice(0);
        this.updateValueAndValidity();
    };

    // patch in what future versions do
    // override to use a spread instead
    // eslint-disable-next-line @typescript-eslint/dot-notation
    FormArray.prototype['push2'] = function (
        ...controls: AbstractControl[]
    ): void {
        this.controls.push(...controls);
        controls.forEach((control) => this._registerControl(control));
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
}
